import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export class transferisServiciosIntegracion {

    static getRutesByIdClient = (id_cliente, setRutas) => {
        api.get(apiUrl + `/monitor/getRutesByIdClient?id_cliente=${id_cliente}`).then((res) => {
            setRutas(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static actualizarEsquema = (data, navigate, setActive) => {
        api.put(apiUrl + `/monitor/programacion/consulta-esquemas/actualizar`, data).then((res) => {
            Swal.fire({
                icon: 'success',   // Icono de error
                title: 'Actualizado correctamente', // Título de la alerta
            });
            setActive(false)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }

    static getEsquemaInfo = (id_esquema, setEsquema) => {
        api.get(apiUrl + `/monitor/programacion/consulta-esquemas?id_esquema=${id_esquema}`).then((res) => {
            setEsquema(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static getEstructuraByRuta = (id_ruta, setEstructura) => {
        api.get(apiUrl + `/monitor/getEstrucuraByIdRoute?id_ruta=${id_ruta}`).then((res) => {
            setEstructura(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static getProveedores = (setProveedores) => {
        api.get(apiUrl + `/monitor/getAllProveedores`).then((res) => {
            setProveedores(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static getOperadores = (setOperadores) => {
        api.get(apiUrl + `/monitor/getOperadoresDisponibles`).then((res) => {
            setOperadores(res.data)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static transferirOperador = (data, setTramsferir) => {
        api.patch(apiUrl + `/monitor/transferir`, data).then((res) => {
            if (res.data.message) {

                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: res.data.message, // Título de la alerta

                });
            }
            else {
                Swal.fire({
                    icon: 'success',   // Icono de error
                    title: `Transferido correctamente`, // Título de la alerta

                });
            }
            setTramsferir(res.data)

        })
            .catch((error) => {
                console.log("error", error);
                Swal.fire({
                    icon: 'error',   // Icono de error
                    title: `No fue posible realizar la transferencia, favor de revisar los campos seleccionados`, // Título de la alerta

                });
            })
    }
    static getBitacora = (desde, hasta, id_estructura, setData, setRegistrarIncidencia) => {
        api.get(apiUrl + `/monitor/getBitacora?fecha_inicio=${desde}&fecha_fin=${hasta}&estructura=${id_estructura}`).then((res) => {


            setData(res.data.res)
            setRegistrarIncidencia(res.data.mostrar_incidencia)

        })
            .catch((error) => {
                console.log("error", error);

            })
    }
    static transferirBitacora = async (bitacora, fecha, operadorCode, motivo,id_usuario) => {

        const params = {
            fecha: fecha,
            id_operador: operadorCode,
            motivo: motivo,
            id_bitacora: bitacora,
            id_usuario:id_usuario
        }
        try {
            const res = await api.patch(apiUrl + `/monitor/transferir-bitacora`, params)
            return res;
        } catch (error) {
            console.log("error", error);
            throw error;
        }

    }
}